export const CHAINS = [
  {
    id: "eth",
    label: "Ethereum",
    image: "/assets/ethnew.svg",
    chainId: 1,
    chainIdHex: "0x1",
    rpc: "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/",
    name: "Ethereum Mainnet",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: [
      "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/",
    ],
    blockExplorerUrls: ["https://etherscan.io"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/ethnew.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0xA0b86a33E6441E9c85dE90dc5C96C423014a9b1e",
      },
      {
        symbol: "WBTC",
        icon: "/assets/tokens/wbtc.svg",
        contractAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      },
      {
        symbol: "LINK",
        icon: "/assets/tokens/link.svg",
        contractAddress: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      },
      {
        symbol: "UNI",
        icon: "/assets/tokens/uni.svg",
        contractAddress: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
      },
      {
        symbol: "PEPE",
        icon: "/assets/tokens/pepe.svg",
        contractAddress: "0x6982508145454ce325dbe47a25d4ec3d2311933",
      },
      {
        symbol: "TOMI",
        icon: "/assets/tokens/tomi.svg",
        contractAddress: "0x4385328Cc4D643CA98DfEa734360C0f596c83449",
      },
      {
        symbol: "GEMS",
        icon: "/assets/tokens/gems.svg",
        contractAddress: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc",
      },
    ],
    popularDexes: ["Uniswap", "SushiSwap", "Balancer"],
  },
  {
    id: "base",
    label: "Base",
    image: "/assets/baselogo.svg",
    chainId: 8453,
    chainIdHex: "0x2105",
    rpc: "https://wiser-crimson-sea.base-mainnet.quiknode.pro/fcb831f09a71d9a387a1b87d25dff15e5c4337d2/",
    name: "Base Mainnet",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: [
      "https://wiser-crimson-sea.base-mainnet.quiknode.pro/fcb831f09a71d9a387a1b87d25dff15e5c4337d2/",
    ],
    blockExplorerUrls: ["https://basescan.org"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/tokens/eth.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      },
      {
        symbol: "USDT",
        icon: "/assets/tokens/usdt.svg",
        contractAddress: "0xfde4c96c8593536e31f229ea8f37b2ada2699bb2",
      },
    ],
    popularDexes: ["Uniswap", "BaseSwap", "Aerodrome"],
  },
  {
    id: "polygon",
    label: "Polygon",
    image: "/assets/polygon.svg",
    chainId: 137,
    chainIdHex: "0x89",
    rpc: "https://polygon-rpc.com",
    name: "Polygon Mainnet",
    nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
    rpcUrls: ["https://polygon-rpc.com"],
    blockExplorerUrls: ["https://polygonscan.com"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/tokens/matic.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      },
      {
        symbol: "WBTC",
        icon: "/assets/tokens/wbtc.svg",
        contractAddress: "0x1BFD67037B42Cf73aF2047067bd4F2C47D9BfD6",
      },
      {
        symbol: "LINK",
        icon: "/assets/tokens/link.svg",
        contractAddress: "0x53e0Bca35eC356BD5dDDFEBbd1Fc0FD03Fabad39",
      },
      {
        symbol: "UNI",
        icon: "/assets/tokens/uni.svg",
        contractAddress: "0xb33EaAd8d922B1083446DC23f610c2567fB5180f",
      },
      {
        symbol: "TOMI",
        icon: "/assets/tokens/tomi.svg",
        contractAddress: "0xCD966B72CFF52Dc349089b6B6f5865B5743b4E08",
      },
    ],
    popularDexes: ["QuickSwap", "Uniswap", "Balancer"],
  },
  {
    id: "arb",
    label: "Arbitrum",
    image: "/assets/arblogo.svg",
    chainId: 42161,
    chainIdHex: "0xa4b1",
    rpc: "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/",
    name: "Arbitrum One",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: [
      "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/",
    ],
    blockExplorerUrls: ["https://arbiscan.io"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/tokens/eth.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      },
      {
        symbol: "WBTC",
        icon: "/assets/tokens/wbtc.svg",
        contractAddress: "0x2f2a2543B76A4166549F7aaB2e75BEF0aefC5B0f",
      },
      {
        symbol: "LINK",
        icon: "/assets/tokens/link.svg",
        contractAddress: "0xF97f4df75117a78c1A5a0DBb814Af92458539FB4",
      },
    ],
    popularDexes: ["Uniswap", "SushiSwap", "Camelot", "GMX"],
  },
  {
    id: "bnb",
    label: "BNB",
    image: "/assets/bnblogo.svg",
    chainId: 56,
    chainIdHex: "0x38",
    rpc: "https://empty-polished-frog.bsc.quiknode.pro/90491c6058af5bc049af6bc351d7215b5933efe9/",
    name: "Binance Smart Chain Mainnet",
    nativeCurrency: { name: "Binance Coin", symbol: "BNB", decimals: 18 },
    rpcUrls: [
      "https://empty-polished-frog.bsc.quiknode.pro/90491c6058af5bc049af6bc351d7215b5933efe9/",
    ],
    blockExplorerUrls: ["https://bscscan.com"],
    commonPurchaseCurrencies: [
      {
        symbol: "BNB",
        icon: "/assets/bnblogo.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      },
      {
        symbol: "USDT",
        icon: "/assets/tokens/usdt.svg",
        contractAddress: "0x55d398326f99059ff775485246999027b3197955",
      },
      // { symbol: "LINK", icon: "/assets/tokens/link.svg", contractAddress: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD" },
      // { symbol: "LTC", icon: "/assets/tokens/ltc.svg", contractAddress: "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94" },
      // { symbol: "AVAX", icon: "/assets/tokens/avax.svg", contractAddress: "0x1CE0c2827e2eF14D5C4f29a091d735A204794041" },
      // { symbol: "DOGE", icon: "/assets/tokens/doge.svg", contractAddress: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43" },
      // { symbol: "XRP", icon: "/assets/tokens/xrp.svg", contractAddress: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE" },
      // { symbol: "SOL", icon: "/assets/tokens/sol.svg", contractAddress: "0x570A5D26f7765Ecb712C0924E4De545B89fD43dF" },
      // { symbol: "DAI", icon: "/assets/tokens/dai.svg", contractAddress: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3" },
      // { symbol: "BTC", icon: "/assets/tokens/btc.svg", contractAddress: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c" },
      {
        symbol: "ETH",
        icon: "/assets/tokens/eth.svg",
        contractAddress: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      },
    ],
    popularDexes: ["PancakeSwap", "ApeSwap", "Wombat Exchange"],
  },
  {
    id: "aval",
    label: "Avalanche",
    image: "/assets/avalogo.png",
    chainId: 43114,
    chainIdHex: "0xa86a",
    rpc: "https://api.avax.network/ext/bc/C/rpc",
    name: "Avalanche C‑Chain",
    nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/tokens/avax.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      {
        symbol: "USDC",
        icon: "/assets/tokens/usdc.svg",
        contractAddress: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      },
      {
        symbol: "WBTC",
        icon: "/assets/tokens/wbtc.svg",
        contractAddress: "0x152b9d0FdC40C096757F570A51E494bd4b943E50",
      },
      {
        symbol: "LINK",
        icon: "/assets/tokens/link.svg",
        contractAddress: "0x5947BB275c521040051D82396192181b413227A3",
      },
    ],
    popularDexes: ["TraderJoe", "Pangolin", "Curve"],
  },
  {
    id: "sepolia",
    label: "Sepolia",
    image: "/assets/sepolia.svg", // <-- Add the icon to your assets folder
    chainId: 11155111,
    chainIdHex: "0xaa36a7",
    rpc: "https://eth-sepolia.g.alchemy.com/v2/n_4iaIl35yi2Vc0AV3-eg9rsdbG95Tfg",
    name: "Ethereum Sepolia Testnet",
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: ["https://eth-sepolia.g.alchemy.com/v2/n_4iaIl35yi2Vc0AV3-eg9rsdbG95Tfg"],
    blockExplorerUrls: ["https://sepolia.etherscan.io"],
    commonPurchaseCurrencies: [
      {
        symbol: "ETH",
        icon: "/assets/tokens/eth.svg",
        contractAddress: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      },
      // Optional: Add testnet tokens here
    ],
    popularDexes: [], // Usually empty for testnets, but add if using any
  },
];
